import { render } from "./SetExpiryLot.vue?vue&type=template&id=4242d7ba"
import script from "./SetExpiryLot.vue?vue&type=script&lang=js"
export * from "./SetExpiryLot.vue?vue&type=script&lang=js"
script.render = render

export default script